import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

type WeekdayFormat = 'EEE' | 'EEEE' | 'EEEEE' | 'EEEEEE';

@Pipe({
  name: 'weekday'
})
export class WeekdayPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}
  
  transform(weekday: number, format: WeekdayFormat = 'EEE'): string {
    const date = new Date();
    const day = date.getDay();
    const diff = weekday - day;
    date.setDate(date.getDate() + diff);
    return this.datePipe.transform(date, format) || '';
  }

}
